import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { SensorsComponent } from '@uigy/modules/sensors/components/sensors/sensors.component';
import { CanDeactivateGuard } from '@uigy/core/guards/can-deactivate.guard';
import { IcpGuard } from '@uigy/core/guards/icp.guard';
import { setCapabilitiesRouteData } from '@uigy/shared/capabilities/capabilities-route-data';
import { Capability } from '@uigy/generated/graphql';
import { CapabilityGuardCanActivate } from '@uigy/core/guards/capability.guard';

@NgModule({
  imports: [
    RouterModule.forChild([{
      path: RoutesStatesNamesEnum.settingsSensors,
      component: SensorsComponent,
      canDeactivate: [CanDeactivateGuard],
      canActivate: [CapabilityGuardCanActivate, IcpGuard],
      data: setCapabilitiesRouteData(Capability.ReadSensors),
    }])
  ]
})
export class SensorsRouterModule {

}
